import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import Lottie from 'react-lottie-player';
import * as animationData from './congratulation.json';
import styles from './styles.module.scss';

const CongratulationGemsBox = (props) => {
    // const { userState, updateUserProfile, getUserProfile } = UseUser();
    const [isOpen, setIsopen] = useState(true);
    const [showSectionToggle, setSectionShowToggle] = useState(false);
    // const ToggleSidebar = () => {
    //   isOpen === true ? setIsopen(false) : setIsopen(true);
    // }
    useEffect(() => {
        setTimeout(() => {
            setSectionShowToggle(true);
        }, 2000);
        setTimeout(() => {
            setSectionShowToggle(false);
        }, 4500);
    }, []);
    // const updateUserData = async() => {
    //   if(userState?.userProfileData && userState?.userProfileData?.id){
    //     updateUserProfile(userState.userProfileData);
    //   }
    // }
    return (
        <>
            {/* {
        showSectionToggle && */}
            <>
                <div
                    className={`${styles.cong_gemsbox} ${showSectionToggle == true ? styles.cong_active : styles.cong_deactive}`}
                >
                    <div className={`${styles.cong_gems_img}`}>
                        <Image
                            src="/assets/gemstarlogo.svg"
                            alt="Logo"
                            layout="fill"
                        />
                    </div>
                    <div className={`${styles.cong_gems_details}`}>
                        <p className={`${styles.cong_titles}`}>
                            {props?.title}
                        </p>
                        <p className={`${styles.cong_gemsdetails}`}>
                            Congratulations!!
                        </p>

                        <div className={`${styles.cong_gems_title_separates}`}>
                            <h2 className={`${styles.cong_gemstitles}`}>
                                You Have Earned -
                            </h2>
                            <span
                                className={`${styles.cong_gemsvalues} ${styles.cong_gemstitles}`}
                            >
                                {props?.earnedGems || 0}
                            </span>

                            <div className={`${styles.cong_gems_small_img}`}>
                                <Image
                                    src="/assets/gemssimple.svg"
                                    alt="Logo"
                                    layout="fill"
                                />
                            </div>
                        </div>

                        <div className={`${styles.cong_gems_title_separates}`}>
                            <h2 className={`${styles.cong_gemstitles}`}>
                                Current Gems -
                                <span className={`${styles.cong_gemsvalues}`}>
                                    {props?.gems ? props?.gems : 0.25}
                                </span>
                            </h2>
                            <div className={`${styles.cong_gems_small_img}`}>
                                <Image
                                    src="/assets/gemssimple.svg"
                                    alt="Logo"
                                    layout="fill"
                                />
                            </div>
                        </div>
                    </div>

                    <div className={`${styles.nodata_img}`}>
                        <Lottie loop animationData={animationData} play />
                    </div>
                </div>
                {/* <div className={`${styles.cong_icons}`} onClick={ToggleSidebar}>
            <div 
              className={`${isOpen == true ? styles.cong_norotate_icons : styles.cong_rotate_icons}`}
            >
              <SVG
                src="/assets/vectors/arrow_right.svg"
              />
            </div>
          </div> */}
            </>
            {/* } */}
        </>
    );
};
export default CongratulationGemsBox;
